import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { NumericFormat } from "react-number-format";
import bedIcon from "../../assets/bedIcon.png"
import bathIcon from "../../assets/bathIcon.png"
import axios from 'axios';
import { config } from '../../utils/config';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';
import Counter from '../common/Counter'
import { convertToUtcTimeSS } from '../../utils/timeConversion';

export default function BiddingList() {

    const navigate = useNavigate()

    const [data, setData] = useState([]);

    // Search Bar Start

    const searchPropertyName = useCallback(async (e) => {
        console.log(e.target.value)
        // const response = await axios.get('http://localhost:3000/property/get', {
        //     params: {
        //         name: e.target.value
        //     }
        // })
        // const propertyListingData = response.data
        // console.log(response.data)
        // setData(() => propertyListingData)
    }, [])

    const searchListingType = useCallback(async (e) => {
        // console.log(e.target.value)
        // const response = await axios.get('http://localhost:3000/property/get', {
        //     params: {
        //         listing: e.target.value
        //     }
        // })
        // const propertyListingData = response.data
        // console.log(response.data)
        // setData(() => propertyListingData)
    }, [])

    const searchPropertyType = useCallback(async (e) => {
        // console.log(e.target.value)
        // const response = await axios.get('http://localhost:3000/property/get', {
        //     params: {
        //         type: e.target.value
        //     }
        // })
        // const propertyListingData = response.data
        // console.log(response.data)
        // setData(() => propertyListingData)
    }, [])


    // Search Bar End

    const toBidPage = useCallback((biddingId) => {

        navigate(`/bidding/${biddingId}`)

    }, [navigate])


    useEffect(() => {

        const getPropertyData = async () => {
            const response = await axios.get(`${config.apiBaseUrl}/listings/bid`)
            const propertyListingData = response.data
            console.log(response.data)
            setData(() => propertyListingData)
        }

        getPropertyData()

    }, [])

    return (
        <>
            <div className="container-fluid p-1" style={{ width: "90%" }}>
                {/*Search Bar Start  */}
                <div className="d-flex justify-content-center">
                    <Navbar bg="light" variant="light">
                        <Container>
                            <Nav className="me-auto flex-column flex-md-row">
                                <div className="d-flex justify-content-center mb-3 mb-md-0">
                                    <Form className="d-flex">
                                        <Form.Control
                                            placeholder="Search"
                                            style={{ width: "350px" }}
                                            className="me-2"
                                            aria-label="Search"
                                            type="text"
                                            onChange={searchPropertyName}
                                        />
                                    </Form>
                                </div>
                                <div className="d-flex justify-content-center mb-3 mb-md-0 pe-2">
                                    <Form.Select aria-label="Default select example" onChange={searchListingType}>
                                        <option >Sale/Rent</option>
                                        <option value="For Sale">For Sale</option>
                                        <option value="For Rent">For Rent</option>
                                    </Form.Select>
                                </div>
                                <div className="d-flex justify-content-center pe-2">
                                    <Form.Select aria-label="Default select example" onChange={searchPropertyType}>
                                        <option >Property Type</option>
                                        <option value="HDB">HDB</option>
                                        <option value="Condo">Condo</option>
                                        <option value="Landed">Landed</option>
                                        <option value="Retail">Retail</option>
                                        <option value="Office">Office</option>
                                        <option value="Industrial">Industrial</option>
                                    </Form.Select>
                                </div>
                            </Nav>
                        </Container>
                    </Navbar>

                </div>

                {/* Search Bar End */}
                <h5 className="m-3">{data.length} Properties Available for Bidding</h5>

                <div className='container'>

                    <div className="row row-cols-1 row-cols-md-3 g-4">

                        {data.map((obj) => {
                            return (
                                <div className="col" key={obj.id} onClick={() => { toBidPage(obj.id) }}>

                                    <div className="card border-light h-100">

                                        <img src={obj.listingDetails.media[0].media_url} className="card-img-top" alt="..." />

                                        <div className="card-body">
                                            {obj.listingDetails.propertyDetails.project_name && obj.listingDetails.propertyDetails.project_name !== "Nil" ? <h5 className="card-title">{obj.listingDetails.propertyDetails.project_name}</h5> :
                                                <h5 className="card-title">{obj.listingDetails.propertyDetails.street_name}</h5>}
                                            <div className="card-img-overlay">
                                                <h6><span className="badge bg-secondary">{obj.bid_type}</span><span className="badge bg-danger"><Counter dateTime={convertToUtcTimeSS(obj.start_time)} /></span></h6>
                                            </div>

                                            <p className="card-text" style={{ margin: "0", lineHeight: "1.5" }}>{obj.listingDetails.size_land ? null : obj.listingDetails.propertyDetails.block} {obj.listingDetails.propertyDetails.street_name}</p>
                                            <p className="card-text" style={{ fontSize: "14px", margin: "0", lineHeight: "1.5" }}>
                                                <NumericFormat className="card-text" prefix={"$"} suffix={""} thousandSeparator={true} value={obj.listingDetails.price} displayType={"text"} />
                                                {" . "}<NumericFormat className="card-text" prefix={"$"} suffix={"psf (floor)"} thousandSeparator={true} value={Math.round(obj.listingDetails.price / obj.listingDetails.size_built)} displayType={"text"} />
                                                {obj.listingDetails.size_land ? <NumericFormat className="card-text" prefix={" . $"} suffix={"psf (land)"} thousandSeparator={true} value={Math.round(obj.listingDetails.price / obj.listingDetails.size_land)} displayType={"text"} /> : null}
                                            </p>
                                            <p className="card-text" style={{ fontSize: "14px", margin: "0", lineHeight: "1.5" }}>
                                                {obj.listingDetails.room}{" "}<img src={bedIcon} style={{ width: "20px" }} />
                                                {" " + obj.listingDetails.bath + " "}<img src={bathIcon} style={{ width: "20px" }} />
                                                {" . "}<NumericFormat className="card-text" prefix={""} suffix={"sqft (floor)"} thousandSeparator={true} value={obj.listingDetails.size_built} displayType={"text"} />
                                                {obj.listingDetails.size_land ? <NumericFormat className="card-text" prefix={" . "} suffix={"sqft (land)"} thousandSeparator={true} value={obj.listingDetails.size_land} displayType={"text"} /> : null}
                                            </p>
                                            <p className="card-text" style={{ fontSize: "14px", margin: "0", lineHeight: "3" }}>
                                                <span className="btn btn-outline-danger disabled" style={{ fontSize: "12px", padding: "2px" }}>{obj.listingDetails.propertyDetails.tenure}</span>
                                                {"   "}<span className="btn btn-outline-danger disabled" style={{ fontSize: "12px", padding: "2px" }}>{obj.listingDetails.propertyDetails.property_sub_type}</span>
                                            </p>

                                        </div>
                                        <div className="card-footer" style={{ backgroundColor: "white" }}>
                                            <div className='container'>
                                                <p style={{ fontSize: "14px", margin: "0", lineHeight: "1.5" }} className="fw-bold">{obj.listingDetails.agents[0].firstName} {obj.listingDetails.agents[0].lastName}
                                                    <span style={{ fontSize: "13px", margin: "0", lineHeight: "1.5" }} className="fw-normal mx-1">({obj.listingDetails.agents[0].ceaNo})</span></p>
                                                <p style={{ fontSize: "14px", margin: "0", lineHeight: "1.5" }} className="fw-normal">Mobile: {obj.listingDetails.agents[0].mobileNo}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div >
        </>
    )
}